import { get, some, isEmpty } from 'lodash/fp';
import { createSelector } from 'reselect';

import applyOrderItemsAdjustment from '../../../../helpers/pos/applyOrderAdjustment';

export const getPosOrderAdjustment = get('POS.orderAdjustment');

export const hasOrderAdjustment = createSelector(
  getPosOrderAdjustment,
  some(each => !isEmpty(each))
);

export const getOrderItemsWithAdjustment = createSelector(
  (_, orderItems) => orderItems,
  getPosOrderAdjustment,
  applyOrderItemsAdjustment
);

export const getAddItemAdjustment = createSelector(
  getPosOrderAdjustment,
  get('add')
);

export const getUpdateItemAdjustment = createSelector(
  getPosOrderAdjustment,
  get('update')
);

export const getDeleteItemAdjustment = createSelector(
  getPosOrderAdjustment,
  get('delete')
);
